import { useState } from 'react'

import { useTranslations } from 'next-intl'

import classNames from 'classnames'

import type { ArtworkCardProps } from '~/components/atoms/ArtworkCard/ArtworkCard'
import ArtworkCard from '~/components/atoms/ArtworkCard/ArtworkCard'
import Container from '~/components/atoms/Container/Container'
import DynamicSlider from '~/components/atoms/DynamicSlider'
import type { TSearchAnalystEventProps } from '~/services/elastic/analyst'

import styles from './ArtworksSlider.module.css'

export interface ArtworksSliderProps {
  artworks: ArtworkCardProps[]
  title: string
  insightsQueryID?: string
  testID?: string
  searchInsightsEvents?: {
    artwork: TSearchAnalystEventProps
    artist?: TSearchAnalystEventProps
  }
  viewAlleventName?: string
  offwhite?: boolean
  viewAllLink?: string
  viewAllLabel?: string
  noArtistLink?: boolean
}

export default function ArtworksSlider({
  artworks,
  title,
  insightsQueryID,
  testID,
  searchInsightsEvents,
  offwhite = false,
  viewAllLink,
  viewAllLabel,
  viewAlleventName,
  noArtistLink,
}: ArtworksSliderProps) {
  const t = useTranslations('common')
  const [hasInteracted, setHasInteracted] = useState(false)
  const finalViewAllLabel = viewAllLabel || t('viewAll')

  return (
    <div className={styles.outer} data-testid={testID}>
      <div className={styles.wrap}>
        <Container
          cssClass={classNames(
            styles.sliderContainer,
            offwhite && styles.sliderContainerOffwhite
          )}
        >
          <DynamicSlider
            slidesPerView={1.22}
            slidesPerViewMed={2}
            slidesPerViewLrg={3}
            slidesPerViewHuge={4}
            overflowVisible={true}
            title={title}
            spaceBetween={32}
            // loop={true}
            onChange={() => {
              setHasInteracted(true)
            }}
            hideArrowsMobile
            viewAllLink={viewAllLink}
            viewAllLabel={finalViewAllLabel}
            useScrollbar
            wrapperClass={styles.sliderWrapperClass}
            viewAllEventName={viewAlleventName}
          >
            {artworks &&
              artworks.map((item: ArtworkCardProps, i: number) => {
                return (
                  <ArtworkCard
                    {...item}
                    key={`related-artwork-card-${i}`}
                    className={styles.sliderCard}
                    insightsQueryID={insightsQueryID}
                    itemIndex={i + 1}
                    searchInsightsEvents={searchInsightsEvents}
                    noArtistLink={noArtistLink}
                    noLazyLoad={hasInteracted}
                  />
                )
              })}
          </DynamicSlider>
        </Container>
      </div>
    </div>
  )
}
